import { grey } from "@mui/material/colors";
import { LIGHT_GREY } from "styles/oneOffColor";

import { LIGHT_YELLOW } from "features/Influencer/SplashPage/PitchPlease/styles";

const styles = {
  poweredByLogo: {
    my: 1,
    width: { xs: 50, md: 70 },
  },
  root: {
    position: { xs: "relative", md: "absolute" },
    overflow: "hidden",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  sidebar: (isOOOFlow?: boolean) => ({
    p: { xs: 2, md: 4 },
    backgroundColor: isOOOFlow ? LIGHT_YELLOW : LIGHT_GREY,
    position: { xs: "relative", md: "absolute" },
    top: { xs: 0, md: 20 },
    left: { xs: 0, md: 20 },
    bottom: 0,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    width: { xs: "100%", md: "45%" },
    overflowY: "auto",
  }),
  main: {
    position: { xs: "relative", md: "absolute" },
    top: 0,
    bottom: 0,
    left: { xs: 0, md: "45%" },
    right: 0,
    p: { xs: 2, md: 4, lg: 6 },
    overflowY: "auto",
  },
  tab: {
    color: grey[700],
    textTransform: "none",
    fontSize: 11,
    borderRadius: 4,
  },
  active: {
    px: 2,
    color: "black",
    backgroundColor: "white",
  },
  annotation: {
    position: "relative",
    verticalAlign: "middle",
    fontSize: 10,
    ml: 0.5,
    color: "purple.main",
  },
  coupon: {
    fontSize: 10,
    backgroundColor: "white",
    color: "green.main",
    borderRadius: 4,
    "&:hover": {
      backgroundColor: "yellow.main",
    },
  },
};

export default styles;
